import { forwardRef } from 'react';

import { Anchor, AnchorProps, Text, TextProps, createPolymorphicComponent } from 'ui';

type AnchorCellProps = AnchorProps & {
  textProps?: TextProps;
  children: React.ReactNode;
};

const _AnchorCell = forwardRef<HTMLAnchorElement, AnchorCellProps>(
  // eslint-disable-next-line id-length
  ({ children, textProps, c = 'gray', fz = 'xs', ...props }, ref) => {
    return (
      <Anchor
        td="underline"
        onContextMenu={(e) => e.stopPropagation()}
        w="fit-content"
        display="inline-block"
        c={c}
        fz={fz}
        {...props}
        ref={ref}
      >
        <Text w="fit-content" c="inherit" fz="inherit" {...textProps}>
          {children}
        </Text>
      </Anchor>
    );
  }
);

_AnchorCell.displayName = 'AnchorCell';

/**
 * This component is used to create a cell that contains an anchor link that also stops the context menu from appearing on right-click.
 * Use the `href` prop if wanting to use as a normal anchor tag.
 * If client-side routing, use the `component` prop to pass in NavLink or other components.
 *
 * @example
 * <AnchorCell component={NavLink} to={`./${props.row.original.uuid}`}>{props.row.original.name}</AnchorCell>
 *
 * @example
 * <AnchorCell href={`./${props.row.original.uuid}`}>{props.row.original.name}</AnchorCell>
 */
const AnchorCell = createPolymorphicComponent<'a', AnchorCellProps>(_AnchorCell);

export { AnchorCell };
export type { AnchorCellProps };
